import { render, staticRenderFns } from "./WaybillFlightPhotos.vue?vue&type=template&id=4da99bbe&scoped=true&"
import script from "./WaybillFlightPhotos.vue?vue&type=script&lang=js&"
export * from "./WaybillFlightPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da99bbe",
  null
  
)

export default component.exports
import {QImg,QRadio,QIcon,QCheckbox} from 'quasar'
component.options.components = Object.assign({QImg,QRadio,QIcon,QCheckbox}, component.options.components || {})
